export const ADD_MARKUP_PRICE = "ADD_MARKUP_PRICE";
export const ADD_MARKUP_PRICE_SUCCESS = "ADD_MARKUP_PRICE_SUCCESS";
export const ADD_MARKUP_PRICE_FAILED = "ADD_MARKUP_PRICE_FAILED";

export const SEND_MARKUP_TICKET = "SEND_MARKUP_TICKET";
export const SEND_MARKUP_TICKET_SUCCESS = "SEND_MARKUP_TICKET_SUCCESS";
export const SEND_MARKUP_TICKET_FAILED = "SEND_MARKUP_TICKET_FAILED";

